import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

/**
 * Google logic for search results is more complex that just the schema and it also looks in the page to collect data
 * data-nosnippet attribute will prevent google from displaying data wrapped inside the element in google results
 * https://developers.google.com/search/docs/crawling-indexing/robots-meta-tag
 * @param currentPrescriptionType
 * @returns
 */
export const productAccessorGetDataNoSnippetAttributeForInsurancePrescription =
  (
    currentPrescriptionType: PrescriptionPrescriptionTypeEnum,
  ): Record<string, string> => {
    return currentPrescriptionType ===
      PrescriptionPrescriptionTypeEnum.InsurancePrescription
      ? { 'data-nosnippet': 'true' }
      : {}
  }
